// extracted by mini-css-extract-plugin
module.exports = {"preview":"preview_preview__1hR-v","post":"preview_post__ZReAT"};